"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContent = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const loader_1 = require("@festival/component/loader");
const classnames_1 = require("classnames");
class ListContent extends React.Component {
    render() {
        const { pageConfigurationStore, routeManager } = this.props;
        if (!pageConfigurationStore || !routeManager) {
            return null;
        }
        const ticketing = pageConfigurationStore.get('ticketing');
        if (!ticketing) {
            return null;
        }
        if (!ticketing.complete) {
            return React.createElement(loader_1.default, null);
        }
        const ticketingComplete = ticketing;
        if (!ticketingComplete.details) {
            return null;
        }
        return this.renderContent(ticketingComplete.details);
    }
    renderContent(details) {
        const { className } = this.props;
        return (React.createElement("div", { id: "ticketing", className: classnames_1.default(className) },
            this.renderPrices(details.prices),
            this.renderBooks(details.books, details.booksNotes),
            this.renderVip(details.vipContent, details.vipContentNotes)));
    }
    renderPrices(prices) {
        return (React.createElement(reactstrap_1.Card, { body: true, id: "prices", className: "mb-2" },
            React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                this.titlePrefix,
                React.createElement(react_intl_1.FormattedMessage, { id: "ticketing.prices.title" })),
            this.renderPricesContent(prices)));
    }
    renderPricesContent(prices) {
        if (prices === undefined || prices.length === 0) {
            return (React.createElement(reactstrap_1.Alert, { color: "warning" },
                React.createElement(react_intl_1.FormattedMessage, { id: "ticketing.prices.empty" })));
        }
        return (React.createElement("ul", { className: "list-inline" }, prices.map((price, index) => (React.createElement("li", { key: index, className: "list-inline-item" },
            price.primary,
            " : ",
            price.price,
            "\u20AC",
            price.secondary && (React.createElement("span", { className: "text-muted ml-2" }, price.secondary)))))));
    }
    renderBooks(books, booksNotes) {
        if (!books && !booksNotes) {
            return null;
        }
        return (React.createElement(reactstrap_1.Card, { body: true, id: "books", className: "mb-2" },
            React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                this.titlePrefix,
                React.createElement(react_intl_1.FormattedMessage, { id: "ticketing.books.title" })),
            this.renderBooksContent(books, booksNotes)));
    }
    renderBooksContent(books, booksNotes) {
        if (!books && !booksNotes) {
            return null;
        }
        return React.createElement(React.Fragment, null,
            books && books.length > 0 && (React.createElement("ul", { className: "list-inline" }, books.map((document, index) => (React.createElement("li", { key: index, className: "list-inline-item" },
                React.createElement(reactstrap_1.Button, { color: "primary", tag: "a", href: document.available ? document.link : '#', target: "_blank", rel: "noreferrer", disabled: !document.available || !document.link }, document.title)))))),
            (booksNotes) && (React.createElement(reactstrap_1.Alert, { color: "info" }, booksNotes)));
    }
    renderVip(vipContent, vipContentNotes) {
        if (!vipContent || vipContent.length === 0) {
            return null;
        }
        return (React.createElement(reactstrap_1.Card, { body: true, id: "vip-content", className: "mb-2" },
            React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                this.titlePrefix,
                React.createElement(react_intl_1.FormattedMessage, { id: "ticketing.vip-content.title" })),
            this.renderVipContent(vipContent, vipContentNotes)));
    }
    renderVipContent(vipContent, vipContentNotes) {
        if (!vipContent || vipContent.length === 0) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement(react_intl_1.FormattedMessage, { id: "ticketing.vip-content.content" })),
            React.createElement("ul", null, vipContent.map((content, index) => (React.createElement("li", { key: index },
                content.primary,
                content.secondary && (React.createElement("span", { className: "text-muted" }, content.secondary)))))),
            vipContentNotes && (React.createElement("p", null, vipContentNotes))));
    }
    get titlePrefix() {
        return null;
    }
}
exports.ListContent = ListContent;
exports.default = mobx_react_1.inject('pageConfigurationStore', 'routeManager')(mobx_react_1.observer(ListContent));
